<template>
    <div class="settingsBlock">
        <table class="table fz13">
            <tr class="fz13">
                <th>                    
                    <span>Name</span>
                </th>
                <th>                    
                    <span>Custom value</span>
                </th>
                <th>                    
                    <span>Default value</span>
                </th>
                <th>                    
                    <span>Description</span>
                </th>
            </tr>            
            <SettingCardList
                v-for="setting in settings" :key="setting.id"
                :setting = setting
            />
            <tr class="black_line">
                <td>

                </td>
                <td>

                </td>
                <td>

                </td>
                <td>
                    <button @click="saveSettings" class="btn btn-border-light">SAVE</button>
                </td>
            </tr>
        </table>
    </div>
</template>

<script>
import {bus} from '../bus';
import axios from 'axios';

import Dotscontrol from './Dotscontrol';
import iconsort from "./iconsort";
import hrdate from "./hrdate";
import SettingCardList from "./Settings/SettingCardList";

export default {
    data(){
        return{            
            model_all: false,
            listdelete: [],
            btn_delete_all: true,
            model_find: '',
            settings: []
        }
    },
    methods: {
       saveSettings(){           
           bus.$emit('updateSetting');
       },       
        getSettings() {            
            const url = `/settings/`;
            const params = {};
            axios.get(
                url,
                {
                    params: params,
                    headers: {
                        'ContentType': 'application/json'
                    }
                }
            ).then((response) => {
                this.data = response.data;
                this.settings = response.data;
            }).catch( (error) => {
                // handle error
                console.log(error);
            });
        }
    },
    watch: {},
    mounted(){
        this.getSettings();
    },
    computed: {},
    components: {        
        iconsort,
        hrdate,
        SettingCardList
    }
}
</script>

<style lang="scss">
    .settingsBlock {
        max-width: 800px;
        // background-color: #000A10;
        padding: 20px;
        font-size: 17px;
        border-radius: 0 0 3px 3px;
        overflow: hidden;
        .table {
            color: #E0E0E0;
            // border: 20px solid #000A10;
            // border-top: none;
        }
        tr.black_line {
            border-top: none;
            border-bottom: none;
            border-right: 20px solid #000A10;
            border-left: 20px solid #000A10;            
        }
        tr.black_line:last-child {
            border-radius: 5px;
        }
        tr.black_line:last-child td {
            border-bottom: none;            
        }
        .table td {
            padding-top: 20px;
            padding-bottom: 20px;
            border-bottom: 1px solid rgba($color: #fff, $alpha: 0.2);
        }
        table .btn {            
            padding: 0.375rem 2.75rem;
            font-weight: 600;
            color: #ffffff9e;
        }
    }
        
</style>
